export const S3_BUCKET = process.env.REACT_APP_ENV === 'prod' ? 'confidant-health-prod' : 'confidant-health';

export const S3_BUCKET_URLL = `https://${S3_BUCKET}.s3.amazonaws.com/`;
